import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
	styles: {
		global: {
			html: { scrollBehavior: "smooth" },
			body: { bg: "brand.light", color: "brand.dark" },
		},
	},
	fonts: {
		heading: `'Kalnia Variable', serif`,
		body: `'Libre Baskerville', serif`,
	},
	colors: {
		brand: {
			light: "#FFFEFA",
			mid: "#faf5f1",
			dark: "#2B492C",
			contrast: "#CF4425",
		},
	},
	components: {
		Heading: {
			baseStyle: {
				fontWeight: "medium",
			},
		},
		Button: {
			baseStyle: {
				fontWeight: "medium",
			},
		},
	},
});
